export default (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <rect width="24" height="24" rx="4" fill="#1E3A8A" />
    <path d="M7 17V7h2l5 6.5V7h2v10h-2l-5-6.5V17H7z" fill="white" />
  </svg>
);
